import React from 'react';
import { connect } from 'react-redux';
import { closeActiveModal } from '@confluence-classic/confluence-utils/src/actions/modal.js';

import SingleModal from './SingleModalComponent.js';

const mapStateToProps = ({ modal: { modalComponent, modalProps } }) => ({
	modalComponent,
	modalProps,
});

export default connect(mapStateToProps, {
	closeActiveModal,
})(SingleModal);
